import { useEffect } from "react";
import useIsDesktop from "../hooks/useIsDesktop";
import { Headers } from "../components/ui/heading";
import { FundsTransferContent } from "../components/FundsTransfer/FundsTransferContent";
import { useFundsTransferBanner } from "../components/FundsTransfer/shared/useFundsTransferBanner";
import { useOtpBlockCountdown } from "../hooks/useOtpBlockCountdown";
import { OtpBlockBanner } from "../components/shared/OtpBlockBanner";
import CustomNotificationBanner from "../components/ui/CustomNotificationBanner/CustomNotificationBanner";
import useFundsTransferStore from "../stores/fundsTransferStore";
import { useFundsTransferOtpBlockStore } from "../stores/useOtpBlockStore";

function FundsTransfer() {
  const isDesktop = useIsDesktop();
  const { banner, dismissBanner } = useFundsTransferBanner();
  const { isBlocked, countdown } = useOtpBlockCountdown(
    useFundsTransferOtpBlockStore,
  );

  useEffect(() => {
    useFundsTransferStore.getState().reset();
  }, []);

  return (
    <div className="p-6 sm:min-h-full sm:flex sm:items-center sm:justify-center pb-16">
      <div className="max-w-[1480px] w-full">
        {isBlocked && <OtpBlockBanner countdown={countdown} />}

        {!isBlocked && banner && (
          <div className="mb-6 flex justify-center">
            <CustomNotificationBanner
              variant={banner.variant}
              title={banner.title}
              message={banner.message}
              onClose={dismissBanner}
              maw={440}
            />
          </div>
        )}

        {isDesktop ? (
          <div className="text-center mb-10">
            <h1 className="text-2xl font-semibold text-gray-900">
              Funds Transfer
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Withdraw funds to your mobile money, bank, or Paykit account
            </p>
          </div>
        ) : (
          <Headers
            name="Funds Transfer"
            subtitle="Withdraw funds to your mobile money, bank, or Paykit account"
          />
        )}

        <FundsTransferContent isBlocked={isBlocked} />
      </div>
    </div>
  );
}

export default FundsTransfer;
